import { CanvasElementType } from '../canvas-types';

export const SUPPORTED_SECTIONS_DROP_ELEMENTS = [
  CanvasElementType.STANDALONE_NODE,
  CanvasElementType.STICKY_NOTE,
  CanvasElementType.GROUP,
  CanvasElementType.GROUP_LABEL,
  CanvasElementType.TEXT_NODE,
];
